/**
 * Estado del panel de chat con IA (`ChatIaPanel`): abierto/cerrado y la columna de historial.
 *
 * Desde `lg` el historial es una columna junto al chat y arranca visible al abrir el panel;
 * debajo de `lg` es una vista que tapa el chat, así que al elegir algo hay que volver al chat
 * (`volverAlChat`). Debajo de `sm` el panel ocupa toda la pantalla: navegar debe cerrarlo
 * (`cerrarEnPantallaChica`).
 */
import { useCallback, useRef, useState } from "react";

const coincide = (consulta: string) => {
  try {
    return window.matchMedia(consulta).matches;
  } catch {
    return false;
  }
};
export const esPantallaChica = () => coincide("(max-width: 639px)");
export const esPantallaAncha = () => coincide("(min-width: 1024px)");

export function useChatIaPanel() {
  const [abierto, setAbiertoEstado] = useState(false);
  const [historialAbierto, setHistorialAbierto] = useState(false);
  const abiertoRef = useRef(false);

  const setAbierto = useCallback((o: boolean) => {
    // Al abrir en pantalla ancha, el historial arranca visible: es parte del flujo diario.
    if (o && !abiertoRef.current) setHistorialAbierto(esPantallaAncha());
    abiertoRef.current = o;
    setAbiertoEstado(o);
  }, []);

  const alternar = useCallback(() => setAbierto(!abiertoRef.current), [setAbierto]);
  const alternarHistorial = useCallback(() => setHistorialAbierto((v) => !v), []);

  const volverAlChat = useCallback(() => {
    if (!esPantallaAncha()) setHistorialAbierto(false);
  }, []);

  const cerrarEnPantallaChica = useCallback(() => {
    if (esPantallaChica()) setAbierto(false);
  }, [setAbierto]);

  return { abierto, setAbierto, alternar, historialAbierto, alternarHistorial, volverAlChat, cerrarEnPantallaChica };
}
